/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Creditsunit1Inputs */

const en_creditsunit1 = /** @type {(inputs: Creditsunit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`credits`)
};

const de_creditsunit1 = /** @type {(inputs: Creditsunit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Credits`)
};

/**
* | output |
* | --- |
* | "credits" |
*
* @param {Creditsunit1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const creditsunit1 = /** @type {((inputs?: Creditsunit1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Creditsunit1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_creditsunit1(inputs)
	return de_creditsunit1(inputs)
});
export { creditsunit1 as "creditsUnit" }